/* eslint-disable react/jsx-no-bind */
import LoadingSpinner from "../../bundles/BuyItNow/components/LoadingSpinner";
import PropTypes from "prop-types";
import React from "react";

const QuantityField = ({label, quantity, handleDecreaseQuantity, handleIncreaseQuantity, loading = false}) => (
  <div className="quantity-field">
    {label && (
      <div className="styled_h6 inline bold quantity-label">
        {label}
      </div>
    )}
    <div className={`quantity-buttons ${loading ? "disabled-btn" : ""}`}>
      <div
        className="decrease-quantity-button decrease-btn"
        onClick={handleDecreaseQuantity}
        type="button"
      />
      <span className="quantity-amount">
        {loading && <LoadingSpinner />}
        {!loading && quantity}
      </span>
      <div
        className="increase-quantity-button increase-btn"
        onClick={handleIncreaseQuantity}
        type="button"
      />
    </div>

  </div>
);

QuantityField.defaultProps = {
  "label": null,
  "loading": false
};

QuantityField.propTypes = {
  "handleDecreaseQuantity": PropTypes.func.isRequired,
  "handleIncreaseQuantity": PropTypes.func.isRequired,
  "label": PropTypes.string,
  "loading": PropTypes.bool,
  "quantity": PropTypes.number.isRequired
};

export default QuantityField;
